import SanitaryNapkinCard from "../components/SanitaryNapkinCard";
import ProductRange from "../components/ProductRange";
import SolutionsSection from "../components/SolutionsSection";
import TestimonialSlider from "../components/TestimonialSlider";
import NewSection from "../components/NewSection";
import FAQ from "../components/Faq";
import useMetaTags from "../hooks/useMetaTags"; // Adjust path based on your project structure

const Home = () => {
  useMetaTags({
    title: "Organic Pads - Natural, Eco-Friendly Sanitary Pads for Sustainable Menstruation",
    description: "Experience the comfort of natural, biodegradable, and eco-friendly sanitary pads. Organic Pads ensures a sustainable and rash-free period experience.",
    keywords: "organic pads, eco-friendly sanitary pads, biodegradable pads, sustainable menstrual products, natural period care",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "https://organicpads.shop/",
    ogTitle: "Organic Pads - Natural, Eco-Friendly Sanitary Pads for Sustainable Menstruation",
    ogDescription: "Switch to Organic Pads for a sustainable, chemical-free, and comfortable period experience. Eco-friendly and biodegradable menstrual care.",
    ogImage: "https://organicpads.shop/images/home-banner.jpg",
    ogUrl: "https://organicpads.shop/",
    ogType: "website",
    twitterCard: "summary_large_image",
    twitterTitle: "Organic Pads - Natural, Eco-Friendly Sanitary Pads",
    twitterDescription: "Experience the comfort of biodegradable and eco-friendly sanitary pads with Organic Pads. Sustainable menstrual care made for you.",
    twitterImage: "https://organicpads.shop/images/home-banner.jpg",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
});

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Organic Pads",
    "url": "https://organicpads.shop",
    "description": "Experience the comfort of natural, biodegradable, and eco-friendly sanitary pads. Organic Pads ensures a sustainable and rash-free period experience.",
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "https://organicpads.shop",
      "logo": "https://organicpads.shop//logo.png",
      "sameAs": [
        "https://www.facebook.com/profile.php?id=61573042873807",
        "https://www.instagram.com/organicpads_/",
        "https://www.linkedin.com/company/organic-pads",
        "https://www.youtube.com/channel/UCG5-R0zTI-2DAM14ZC0ZD-A",
        "https://x.com/OrganicPads"
      ]
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://organicpads.shop/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "mainEntity": {
      "@type": "Product",
      "name": "Organic Pads - Eco-Friendly Sanitary Pads",
      "description": "Natural, biodegradable, and eco-friendly sanitary pads for a sustainable and rash-free period experience.",
      "brand": {
        "@type": "Brand",
        "name": "Organic Pads"
      },
      "offers": {
        "@type": "Offer",
        "url": "https://organicpads.shop/shop",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "Organic Pads"
        }
      }
    }
  }
  

  return (
    <>
    <div>
      <div className="absolute top-0 left-0 w-full h-screen ">
        {/* Background color that will show below wave */}
        <div className="absolute inset-0 bg-white" />
        
        {/* Header image container - limited to above wave */}
        <div className="absolute top-0 left-0 w-full overflow-hidden">
          <img 
            src="/images/hero-banner.png" 
            alt="Header" 
            className="w-full h-full object-cover"
          />
        </div>
        
        {/* Animated waves */}
        {/* <div className="absolute bottom-[10vh] left-0 w-full overflow-hidden">
        <svg
          className="w-full"
          viewBox="0 0 1440 400"
          preserveAspectRatio="none"
          style={{ height: '10vh' }}
        >
          <path
            className="animate-wave"
            fill="#ffffff"
            fillOpacity="1"
            d="M0,160L60,170C120,180,240,200,360,200C480,200,600,180,720,160C840,140,960,120,1080,130C1200,140,1320,180,1380,200L1440,220L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          >
            <animate
              attributeName="d"
              dur="3s"
              repeatCount="indefinite"
              values="
                M0,160L60,170C120,180,240,200,360,200C480,200,600,180,720,160C840,140,960,120,1080,130C1200,140,1320,180,1380,200L1440,220L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z;
                M0,140L60,150C120,160,240,180,360,180C480,180,600,160,720,140C840,120,960,100,1080,110C1200,120,1320,160,1380,180L1440,200L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z;
                M0,160L60,170C120,180,240,200,360,200C480,200,600,180,720,160C840,140,960,120,1080,130C1200,140,1320,180,1380,200L1440,220L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            />
          </path>
        </svg>

        
      </div> */}
        {/* Decorative circles */}
        <div className="absolute top-20 right-20 w-32 h-32 rounded-full bg-yellow-100/30" />
        <div className="absolute top-40 left-20 w-48 h-48 rounded-full bg-emerald-100/20" />
      </div>
      <SanitaryNapkinCard />
      <NewSection/>
      <ProductRange />
      <SolutionsSection/>
      <FAQ/>
      <TestimonialSlider/>
    </div>
     {/* Schema Markup */}
     <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};
  
export default Home;
  